import { faLinkSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { StyledIcon } from './index'

type BrokenLinkIconProps = React.SVGProps<SVGSVGElement> & {
  title?: string
}

export const BrokenLinkIcon = ({
  width = 24,
  height = 24,
}: BrokenLinkIconProps): JSX.Element => {
  return (
    <StyledIcon>
      <FontAwesomeIcon icon={faLinkSlash} height={height} width={width} />
    </StyledIcon>
  )
}
